import { render, staticRenderFns } from "./HotVideoItem.vue?vue&type=template&id=78d8654e&"
import script from "./HotVideoItem.vue?vue&type=script&lang=js&"
export * from "./HotVideoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78d8654e')) {
      api.createRecord('78d8654e', component.options)
    } else {
      api.reload('78d8654e', component.options)
    }
    module.hot.accept("./HotVideoItem.vue?vue&type=template&id=78d8654e&", function () {
      api.rerender('78d8654e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/home/components/HotVideoItem.vue"
export default component.exports